var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{ref:"scrollbar"},[_c('div',{style:(_vm.spacerStyle)},_vm._l((_vm.visibleItems),function(item,idx){return _c('div',{key:_vm.startIdx + idx,ref:_vm.setItemRef,refInFor:true},[_vm._t("default",null,{"item":item,"index":_vm.startIdx + idx})],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }